import $ from 'jquery';
import '@accessible360/accessible-slick';

declare global {
	interface JQuery {
		slick(options?: any): JQuery;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	$('.testimonial-listing .testimonials').slick({
		arrows: false,
		autoplay: true,
		adaptiveHeight: true,
		autoplaySpeed: 10000,
		centerMode: true,
		centerPadding: 0,
		cssEase: 'linear',
		dots: true,
		draggable: true,
		fade: false,
		infinite: true,
		pauseOnHover: false,
		slidesToShow: 1,
		variableWidth: true,
		slidesToScroll: 1,
		speed: 500
	});

	/*
	nextArrow: '<button type="button" class="slick-control slick-next" title="Next"><span>Next</span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.4 22" height="22" width="12.4"><title>Next</title><path d="M1.4 0l11 11-11 11L0 20.6 9.6 11 0 1.4z"> </path></svg></button>',
	prevArrow: '<button type="button" class="slick-control slick-prev" title="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.4 22" height="22" width="12.4"><title>Previous</title><path d="M11 22L0 11 11 0l1.4 1.4L2.8 11l9.6 9.6z"> </path></svg> <span>Previous</span></button>',
	slide: '.testimonial',
	*/
})